module.exports = __webpack_public_path__ + "static/quick-order-gif-a8f89eee3756486fcd3825d0fe60d4a6.gif";